import service from '@/utils/service'

//登录
export function login(options){
	return service({
		url:'admin/login/login',
		method:'POST',
		data:options
	})
}

/***** 票据统计  ************************************/
export function getBillData(options){
	return service({
		url:'admin/Invoice/getUserData',
		method:'POST',
		data:options
	})
}

/***** 备忘统计  ************************************/
export function getRemarkData(options){
	return service({
		url:'admin/Beiwang/getUserData',
		method:'POST',
		data:options
	})
}

/********* 文档中心 ******************************************/
export function addDoc(options){
	return service({
		url:'admin/Doc/addDoc',
		method:'POST',
		data:options
	})
}

export function updateDoc(options){
	return service({
		url:'admin/Doc/updateDoc',
		method:'POST',
		data:options
	})
}

export function getDoc(options){
	return service({
		url:'admin/Doc/getDoc',
		method:'GET',
		params:options
	})
}

export function deleteDoc(options){
	return service({
		url:'admin/Doc/deleteDoc',
		method:'POST',
		data:options
	})
}


/***** 测试 *********************************/
export function doLogin(){
	return service({
		url:'admin/Login/getToken',
		method:'GET'
	})
}

export function doTest(){
	return service({
		url:'admin/Dos/doTest',
		method:'GET'
	})
}

export async function refreshToken(){
	service({
		url:'admin/Login/refreshToken',
		method:'GET'
	}).then(res=>{
		sessionStorage.setItem('token',res);
	})
}



// WEBPACK FOOTER //
// ./src/utils/api.js